export function pickupTime(value?:string,timeZone?:string){
 if(!value)return '—';
 if(!timeZone)return 'Time zone unavailable';
 try{return new Intl.DateTimeFormat('en-GB',{timeZone,day:'2-digit',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit',hour12:false}).format(new Date(value));}
 catch{return 'Time unavailable';}
}
export function pickupStatus(value:string,sales:boolean){
 const labels:Record<string,string>={WAITING_STOCK:'Waiting for stock',READY_FOR_PICKUP:'Ready for pickup',WAREHOUSE_ACCEPTED:sales?'Scan phones':'Waiting for agent scans',PENDING_REVIEW:sales?'Waiting for review':'Ready for review',COMPLETED:sales?'Pickup completed':'Stock-out completed',CANCELLED:'Cancelled',EXPIRED:'Expired'};
 return labels[value]??value;
}
